export default "__VITE_ASSET__BB1XZ6aa__"